import logo from "@/assets/logo/logo-icon.png";
import TextLogo from "@/assets/logo/text-logo.png";
import {
  useGetMeQuery,
  // useGetTotalPurchasedCreditAmountQuery,
} from "@/redux/feature/user/userApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { SideBarLinkProps, TUser } from "@/types/types";
import IncoiveIcon from "@/assets/icons/Invoices.svg";
import AcountSettngIcon from "@/assets/icons/AcountSettingIcon.svg";
import BillingSettingIcon from "@/assets/icons/BillinSettingIcons.svg";
import Question from "@/assets/icons/Question.svg";
import { Link, useLocation } from "react-router-dom";
import SignOutIcon from "@/assets/icons/LogoutIcon.svg";
import { logOut } from "@/redux/feature/auth/authSlice";
import { useEffect, useState } from "react";
import { setShowMobileSideBar } from "@/redux/feature/global/globalSlice";
import ActiveIcon from "@/assets/icons/ActiveUserIcon.svg";
import { useCheckFeatureApprovedQuery } from "@/redux/feature/featureFlag/featureFlagApi";
import Sparkle from "@/assets/icons/SparklePurple.svg";
import { FeatureFlagsConstants } from "@/constant";

const MobileSideBarItems = [
  {
    label: "Bills & Invoices",
    icon: <IncoiveIcon />,
    isExternalRedirect:true,
    path: "/billings",
  },
  {
    isExternalRedirect:true,
    label: "Account Settings",
    icon: <AcountSettngIcon />,
    path: "/settings",
  },
  {
    isExternalRedirect:true,
    label: "Billing Settings",
    icon: <BillingSettingIcon />,
    path: "/billing-settings",
  },
  // { icon: <Question />, label: "Help and Feedback", path: "/help" },
];

type MobileSideBarProps = {
  isIntelligenceModalOpen: boolean;
  setIsIntelligenceModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const MobileSideBar = ({
  isIntelligenceModalOpen,
  setIsIntelligenceModalOpen,
}: MobileSideBarProps) => {
  const { showMobileSideBar } = useAppSelector((state) => state.global);
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  const userData: TUser | undefined = data?.data;
  const location = useLocation();
  const dispatch = useAppDispatch();

  // const {
  //   data: totalAmountData,
  //   isError,
  //   error,
  // } = useGetTotalPurchasedCreditAmountQuery(user?.email);

  const pathname = location.pathname;
  const handleLogout = () => dispatch(logOut());

  // User name slice based on name
  const getInitials = (fullName: string) => {
    const nameParts = fullName.split(" ");
    if (nameParts.length > 1) {
      return (
        nameParts[0].slice(0, 1) + nameParts[nameParts.length - 1].slice(0, 1)
      );
    }
    return nameParts[0].slice(0, 1);
  };

  const { token } = useAppSelector((state) => state.auth);

  const { data: isAiMarketPlaceFeatureData } = useCheckFeatureApprovedQuery(
    {
      email: user?.email as string,
      featureKey: FeatureFlagsConstants.AI_MARKET_PLACE,
    },
    {
      skip: !user?.email,
    }
  );
  const isAiMarketPlaceApproved = isAiMarketPlaceFeatureData?.data?.approved;

  const splitUserName = userData?.fullName
    ? getInitials(userData.fullName)
    : "";

  const baseUrl =
    import.meta.env.VITE_NODE_ENV === "development"
      ? import.meta.env.VITE_API_AI_MARKET_PLACE_DEV
      : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_AI_MARKET_PLACE_STAGE
      : import.meta.env.VITE_API_AI_MARKET_PLACE_PROD;

  const handleAiMarketPlaceRedirect = () => {
    if (isAiMarketPlaceApproved) {
      // If this feature approved for this user will redirect to that app
      if (token && user?.email) {
        const params = new URLSearchParams({
          t: token as string,
        });
        window.location.href = `${baseUrl}/auth/verify?${params.toString()}`;
      }
    } else {
      setIsIntelligenceModalOpen(true);
    }
  };

  return (
    <div>
      {/* Sidebar Container */}
      <div
        className={`bg-white absolute ${
          showMobileSideBar ? "-left-[0px]" : "-left-[400px]"
        } transition-all duration-300 ease-in-out z-50 pt-[50px] h-full min-w-[290px] rounded-r-[16px] pb-7 flex flex-col`}
      >
        {/* Logo Section */}
        <div className="flex items-center gap-x-2 cursor-pointer px-6 mb-10">
          <img src={logo} alt="passionbits-logo" />
          <img src={TextLogo} alt="text-logo" />
        </div>

        {/* User Profile Section */}
        <div className="mb-5 px-6">
          <div>
            {userData?.profileImg ? (
              <div className="relative inline-block">
                <div className="w-10 h-10">
                  <img
                    className="w-full h-full rounded-full object-cover"
                    src={userData.profileImg}
                    alt="profile"
                  />
                </div>
                <div className="absolute bottom-[0px] right-[0px]">
                  <ActiveIcon />
                </div>
              </div>
            ) : (
              <div className="size-10 flex justify-center items-center text-[#17457D] rounded-full text-sm font-semibold leading-5 relative bg-[#17457D0F]">
                {splitUserName}
                <div className="absolute bottom-[0px] right-[0px]">
                  <ActiveIcon />
                </div>
              </div>
            )}
          </div>
          <p className="font-semibold pt-2 pb-1 text-body-regular">
            {userData?.fullName}
          </p>
          <p className="font-medium text-[#667085] text-caption2-regular">
            {userData?.email}
          </p>
        </div>

        {/* Sidebar Links */}
        <div>
          <ul className="space-y-[2px] px-3">
            {MobileSideBarItems.map((item, i) => (
              <MobileSideBarLink data={item} pathname={pathname} key={i} />
            ))}
            <button
              onClick={handleLogout}
              className="px-3.5 py-[10px] flex h-full justify-start flex-row gap-x-2 w-full items-center transform ease-in-out transition-all text-[#62636C] bg-white border-none"
            >
              <SignOutIcon />
              <p className="whitespace-nowrap transform ease-in-out transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%]">
                Sign out
              </p>
            </button>
            <button
              onClick={handleAiMarketPlaceRedirect}
              className="px-3.5 py-[10px] flex h-full justify-start flex-row gap-x-2 w-full items-center transform ease-in-out transition-all text-[#62636C] bg-white border-none"
            >
              <Sparkle />
              <p className="whitespace-nowrap transform ease-in-out transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%]">
                Intelligence
              </p>
            </button>
          </ul>
        </div>

        {/* Purchased Plan Section */}
        <div className="space-y-4 px-6 mt-auto">
          <h6 className="text-sm leading-5 tracking-[-1%] font-medium">
            Upgrade Plan
          </h6>
          <div className="border border-[#DEE4EB] p-3 rounded-xl">
            <div className="flex items-center gap-1 mb-3">
              <p className="text-[#121217] text-sm leading-5 tracking-[-1%] font-semibold">
                Standard Plan
              </p>
              <p className="text-[#6941C6] text-xs leading-3 font-medium bg-[#F1E8FF] rounded-2xl px-2 py-[2px]">
                Monthly
              </p>
            </div>
            {/* <BalanceIndicator
              used={
                (totalAmountData?.data || (0 as number)) -
                (data?.data?.credits || (0 as number))
              }
              total={userData?.credits || (0 as number)}
            /> */}
          </div>
        </div>
      </div>

      {/* Overlay when sidebar is open */}
      {showMobileSideBar && (
        <div
          onClick={() => dispatch(setShowMobileSideBar(false))}
          className="absolute bg-black/50 h-full w-full left-0 top-0 z-[44]"
        ></div>
      )}
    </div>
  );
};

export default MobileSideBar;

const MobileSideBarLink = ({
  data,
  pathname,
  isExpanded,
}: SideBarLinkProps) => {
  const dispatch = useAppDispatch();
  const isActive = pathname === data.path || pathname.includes(data.path);
  return (
    <li onClick={() => dispatch(setShowMobileSideBar(false))} className="">
      <Link to={data.path}>
        <div
          className={`${
            isActive
              ? "bg-[#FEF4ED] border border-[#FFD6B9] rounded-[6px] text-[#ED5E00]"
              : "text-[#62636C] bg-white border-none"
          }  px-3 py-[10px] flex h-full justify-start   flex-row gap-x-2 w-full items-center  transform ease-in-out transition-all`}
        >
          <div className="w-[20px]">{data.icon}</div>
          <p
            className={`opacity-100
              whitespace-nowrap transform ease-in-out  transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%]`}
          >
            {data.label}
          </p>
        </div>
      </Link>
    </li>
  );
};

// Balance indicator

interface BalanceIndicatorProps {
  used: number;
  total: number;
}

const BalanceIndicator = ({ used, total }: BalanceIndicatorProps) => {
  const [width, setWidth] = useState<number>(0);
  const percentage = (used / total) * 100;

  useEffect(() => {
    setWidth(0);
    const timer = setTimeout(() => setWidth(percentage), 50);
    return () => clearTimeout(timer);
  }, [used, total, percentage]);

  return (
    <div>
      <div className="h-2 bg-[#00336621] rounded-full overflow-hidden mb-3">
        <div
          className="h-full bg-[#003366] rounded-xl transition-all duration-1000 ease-out"
          style={{ width: `${width}%` }}
        ></div>
      </div>
      <p className="leading-[18px]">
        <span className="text-sm font-medium">{used}</span>{" "}
        <span className="text-xs">used out of </span>
        <span className="text-sm font-medium">{total}</span>
      </p>
    </div>
  );
};
